export { VideoCoreModule } from './video-core.module';
export { VideoSelectorComponent } from './video-selector/video-selector.component';
export { VideoCoreService } from './video-core.service';
export { IVideo } from './video.interface';
